import { ElementNode } from 'lexical';

// Shadow root so children act as top-level blocks — the "+" insert menu / media insertion target the column.
export class ColumnNode extends ElementNode {
    static getType() {
        return 'column';
    }

    static clone(node) {
        return new ColumnNode(node.__key);
    }

    createDOM() {
        const dom = document.createElement('div');
        dom.className = 'gfu-editor-column';
        return dom;
    }

    updateDOM() {
        return false;
    }

    exportDOM() {
        const element = document.createElement('div');
        element.className = 'gfu-editor-column';
        return { element };
    }

    static importJSON() {
        return $createColumnNode();
    }

    exportJSON() {
        return {
            ...super.exportJSON(),
            type: 'column',
            version: 1,
        };
    }

    isShadowRoot() {
        return true;
    }
}

export function $createColumnNode() {
    return new ColumnNode();
}

export function $isColumnNode(node) {
    return node instanceof ColumnNode;
}
